import React from 'react';
import IntellMockNewReport from './Intelligence/IntellMockNewReport';
import BreadCrumbBar from './Layout/Nav/BreadCrumbBar';
import UniversalElasticConnectedList from './UniversalElasticConnectedList';
import CONSTANTS from '../constants';


function ElasticAppHarness({ tenantSetting, appType, headerText, pageType, preview, pollingInterval=null, metaData, searchTerm=null, draftArticles=null}) {
    //this app works to wrap elastic app search, providing filters, breadcrumbs, app name, etc.
    // three apps currently using elastic - Intelligence List Page, News List Page, and Search Results Page

    return (

        <>
            { !preview ?
                <>
                    <BreadCrumbBar appName={appType} />
                    <h1 className='h1 m-b-start-08 m-b-end-08'>{ headerText ? headerText : null }</h1>
                </>
            : null }

            <UniversalElasticConnectedList
                pageType={pageType}
                engineName={CONSTANTS.ELASTIC_ENGINES_BY_APP[appType.toLowerCase()]}
                searchTerm={searchTerm}
                pollingInterval={preview ? null: pollingInterval}
                page={0}
                metaData={metaData}
                numPerPage={preview === true ? 4 : 10}
                tenantSetting={tenantSetting}
                preview={preview}
                onTotalPagesReceived={()=> {}} 
                />        
            <IntellMockNewReport/>
        </>            
    )
}

export default ElasticAppHarness